import Swal from 'sweetalert2';

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const showSuccess = (message: string) => {
  return Toast.fire({
    icon: 'success',
    title: message,
  });
};

export const showError = (message: string) => {
  return Toast.fire({
    icon: 'error',
    title: message,
  });
};

export const showWarning = (message: string) => {
  return Toast.fire({
    icon: 'warning',
    title: message,
  });
};

export const showInfo = (message: string) => {
  return Toast.fire({
    icon: 'info',
    title: message,
  });
};

export const confirmAction = (options: {
  title: string;
  text: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: 'warning' | 'question' | 'info' | 'error' | 'success';
}) => {
  return Swal.fire({
    title: options.title,
    text: options.text,
    icon: options.icon || 'question',
    showCancelButton: true,
    confirmButtonColor: '#000000',
    cancelButtonColor: '#6c757d',
    confirmButtonText: options.confirmButtonText || 'Confirm',
    cancelButtonText: options.cancelButtonText || 'Cancel',
  });
};

